import { useState } from 'react';
import {
  recentSearchesApiV1InternalSearchesRecentGet,
  type AdminRecentSearchPage,
} from '@closet-theory/api';
import { Section } from '@ui/console/primitives';
import { Absent, InsightState, useInsight } from './consumer-insights';
import { Page, Pager } from './components';
import { SearchHistoryFilters, SearchHistoryList } from './search-history-list';

const PAGE = 25;
// Smart search has no entry point in the member app, so admin history is Wardrobe-only.
const SEARCH_SURFACE = 'wardrobe' as const;

export function RecentSearches() {
  const [foundNothing, setFoundNothing] = useState(false);
  const [offset, setOffset] = useState(0);
  const source = useInsight<AdminRecentSearchPage>(
    () =>
      recentSearchesApiV1InternalSearchesRecentGet({
        query: {
          limit: PAGE,
          offset,
          surface: SEARCH_SURFACE,
          ...(foundNothing ? { found_nothing: true } : {}),
        },
      }),
    [foundNothing, offset],
  );
  return (
    <Page
      title="Searches"
      purpose="See the settled Wardrobe searches members made, including the searches that found nothing. This screen is read-only."
    >
      <Section
        title="Recent member searches"
        description="Newest first across all members. Replayed keystrokes are folded into the query the member settled on."
      >
        <SearchHistoryFilters
          foundNothing={foundNothing}
          onFoundNothingChange={(next) => {
            setFoundNothing(next);
            setOffset(0);
          }}
        />
        <InsightState source={source} subject="recent member searches">
          {(page) =>
            page.items.length ? (
              <div className="flex flex-col gap-3">
                <SearchHistoryList searches={page.items} />
                <Pager
                  offset={page.offset}
                  limit={page.limit}
                  total={page.total}
                  onPage={setOffset}
                />
              </div>
            ) : (
              <Absent title="No member searches match these filters.">
                The read succeeded and returned no settled searches to show.
              </Absent>
            )
          }
        </InsightState>
      </Section>
    </Page>
  );
}
